import { render, staticRenderFns } from "./CenterPaymentList.vue?vue&type=template&id=c161b52c&"
import script from "./CenterPaymentList.vue?vue&type=script&lang=js&"
export * from "./CenterPaymentList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports